// eslint-disable-next-line import/no-namespace
import * as firebase from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
// import { getPerformance } from "firebase/performance";

const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: projectId,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
if (!firebase.getApps().length) {
	firebase.initializeApp(firebaseConfig);
}

const app = firebase.getApp();
const auth = getAuth(app);

const databaseId = process.env.REACT_APP_FIREBASE_DATABASE_ID;
const db = databaseId && projectId !== 'ready-rx-cd342' 
  ? getFirestore(app, databaseId) 
  : getFirestore(app);

const functions = getFunctions(app);
// const analytics = getAnalytics(app);
// const performance = getPerformance(app);
// const messaging = getMessaging(app);

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true') {
	console.log("Using local Firebase Functions emulator - API calls will go to https://localhost:5001", projectId !== 'ready-rx-cd342' ? `with ${databaseId}` : '');
	// This causes `httpsCallable()` (but NOT `httpsCallableFromURL()`) to use the local Firebase Functions emulator instead of our cloud-hosted Firebase Functions.
	connectFunctionsEmulator(functions, "127.0.0.1", 5001);

	// Ping the emulator to ensure it's actually running, otherwise warn the developer.
	fetch('http://127.0.0.1:4000/')
		.catch(() => {
			const errMsg = "🚨 Firebase Functions emulator is NOT running!\nPlease run 'npm run serve' in the functions directory."
			console.error(errMsg);
			alert(errMsg);
		});
} else {
	console.log("Using cloud-hosted Firebase Functions from", projectId, projectId !== 'ready-rx-cd342' ? `with ${databaseId}` : '');
}

const buildMetadata = {
  branch: process.env.REACT_APP_GIT_BRANCH || 'local',
  commit: process.env.REACT_APP_GIT_COMMIT || 'unknown',
  time: process.env.REACT_APP_BUILD_TIME ? new Date(process.env.REACT_APP_BUILD_TIME).toString() : 'unknown',
  user: process.env.REACT_APP_BUILD_USER || 'unknown'
};
console.log("Build:", buildMetadata);

// storage loads on the first upload or download, so a page that never touches a file never fetches its sdk
let storageLoad = null;
const loadStorage = () => {
	if (storageLoad === null) {
		storageLoad = import("firebase/storage")
			.then((storageSdk) => ({ ...storageSdk, storage: storageSdk.getStorage(app) }))
			.catch((error) => {
				// a failed load is retried by the next caller rather than remembered
				storageLoad = null;
				throw error;
			});
	}

	return storageLoad;
};

export { firebase, app, auth, db, functions, loadStorage };